import EmblaCarousel from "embla-carousel";

function addDotBtnsAndClickHandlers(emblaApi, dotsNode) {
	let dotNodes = [];

	const addDotBtnsWithClickHandlers = () => {
		dotsNode.innerHTML = emblaApi
			.scrollSnapList()
			.map(
				(_, index) =>
					`<button class="embla__dot" type="button" aria-label="Vai alla slide ${
						index + 1
					}"></button>`
			)
			.join("");

		const scrollTo = (index) => emblaApi.scrollTo(index);

		dotNodes = Array.from(dotsNode.querySelectorAll(".embla__dot"));
		dotNodes.forEach((dotNode, index) => {
			dotNode.addEventListener("click", () => scrollTo(index), false);
		});
	};

	const toggleDotBtnsActive = () => {
		const previous = emblaApi.previousScrollSnap();
		const selected = emblaApi.selectedScrollSnap();
		dotNodes[previous]?.classList.remove("embla__dot--selected");
		dotNodes[selected]?.classList.add("embla__dot--selected");
	};

	emblaApi
		.on("init", addDotBtnsWithClickHandlers)
		.on("reInit", addDotBtnsWithClickHandlers)
		.on("init", toggleDotBtnsActive)
		.on("reInit", toggleDotBtnsActive)
		.on("select", toggleDotBtnsActive);

	return () => {
		dotsNode.innerHTML = "";
	};
}

function addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn) {
	const scrollPrev = () => emblaApi.scrollPrev();
	const scrollNext = () => emblaApi.scrollNext();

	prevBtn.addEventListener("click", scrollPrev, false);
	nextBtn.addEventListener("click", scrollNext, false);

	const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
		emblaApi,
		prevBtn,
		nextBtn
	);

	return () => {
		removeTogglePrevNextBtnsActive();
		prevBtn.removeEventListener("click", scrollPrev, false);
		nextBtn.removeEventListener("click", scrollNext, false);
	};
}

function addTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn) {
	const togglePrevNextBtnsState = () => {
		if (emblaApi.canScrollPrev()) {
			prevBtn.removeAttribute("disabled");
		} else {
			prevBtn.setAttribute("disabled", "disabled");
		}

		if (emblaApi.canScrollNext()) {
			nextBtn.removeAttribute("disabled");
		} else {
			nextBtn.setAttribute("disabled", "disabled");
		}
	};

	emblaApi
		.on("select", togglePrevNextBtnsState)
		.on("init", togglePrevNextBtnsState)
		.on("reInit", togglePrevNextBtnsState);

	return () => {
		prevBtn.removeAttribute("disabled");
		nextBtn.removeAttribute("disabled");
	};
}

// 👉 Funzione principale per inizializzare TUTTI i caroselli sulla pagina
export function initEmbla(selector = ".embla", options = {}) {
	// 👉 Skip su mobile
	// if (window.innerWidth < 1023) {
	// 	console.log("📱 Embla non inizializzato su mobile");
	// 	return;
	// }

	const emblaNodes = document.querySelectorAll(selector);
	if (!emblaNodes.length) return;

	emblaNodes.forEach((emblaNode, index) => {
		const viewportNode = emblaNode.querySelector(".embla__viewport");
		const prevBtnNode = emblaNode.querySelector(".embla__button--prev");
		const nextBtnNode = emblaNode.querySelector(".embla__button--next");
		const dotsNode = emblaNode.querySelector(".embla__dots");

		if (!viewportNode) return;

		const emblaApi = EmblaCarousel(viewportNode, options);

		const removePrevNext = addPrevNextBtnsClickHandlers(
			emblaApi,
			prevBtnNode,
			nextBtnNode
		);
		const removeDots = addDotBtnsAndClickHandlers(emblaApi, dotsNode);

		emblaApi.on("destroy", removePrevNext);
		emblaApi.on("destroy", removeDots);

		console.log(`✅ Embla #${index + 1} inizializzato`);
	});
}
